import { IBaseGetParam } from './resource.model';

export interface IBeneficiaryAddress extends IBeneficiaryBankAddress {
  fullAddress: string;
}

export interface IBeneficiaryBankAddress {
  streetLine1: string;
  streetLine2?: string;
  city: string;
  state: string;
  postalCode: string;
  countryCode: string;
}

export interface ISwiftUnknownBeneficiaryBankAccountDetails {
  bic: string;
  accountNumber: string;
}

export interface IBeneficiaryPayload {
  accountHolderName?: string;
  bankName: string;
  beneficiaryEmail: string;
  currencyCode: string;
  businessName?: string;
  firstName?: string;
  lastName?: string;
  accountOwnerType: number;
  transactionType: string;
  paymentMethod: string;
  swiftPayment: ISwiftBeneficiaryBankAccountDetails;
  localAccountPayment: IUsdLocalBeneficiaryBankAccountDetails;
  ibanPayment: IIbanBeneficiaryBankAccountDetails;
  unKnownPayment: ISwiftUnknownBeneficiaryBankAccountDetails;
  paymentType: number;
  beneficiaryAddress: IBeneficiaryAddress;
}

export interface IBeneficiaryLocationTransaction {
  currencyCode: string;
  transactionType: string;
  paymentMethod: string;
}

export interface IBeneficiaryPersonalInfo {
  accountOwnerType: number;
  accountHolderName: string;
  beneficiaryEmail: string;
  beneficiaryAddress: IBeneficiaryAddress;
}

export interface IBeneficiaryBankAccountDetails {
  accountOwnerType: string;
  accountHolderName: string;
  beneficiaryEmail: string;
  beneficiaryAddress: IBeneficiaryAddress;
}

interface IIBanAccount {
  countryCode: string;
  bic: string;
  ibanAccount: string;
}

export interface IUsdLocalBeneficiaryBankAccountDetails {
  accountNumber: string;
  routingNumber: string;
  checkingOrSavings: string;
}

export interface ISwiftBeneficiaryBankAccountDetails {
  bankAddress: IBeneficiaryBankAddress;
  ibanAccount: IIBanAccount;
  category: string;
}

export interface IIbanBeneficiaryBankAccountDetails {
  countryCode: string;
  bic: string;
  ibanAccount: string;
}

export enum PaymentMethodEnum {
  SWIFT = 1,
  IBAN = 2,
  USDLocal = 3,
  SWIFTUNKNOWN = 4,
}

export enum accountOwnerTypeEnum {
  individual = 1,
  business = 2,
}

export interface IGetBeneficiariesParam extends IBaseGetParam {
  accountHolderName?: string;
  currencyCode?: string;
}

export interface IGetBeneficiary {
  id: string;
  bankName: string;
  isVerified: boolean;
  beneficiaryEmail: string;
  currencyCode: string;
  accountHolderName: string;
  accountOwnerType: number;
  localAccountPayment: IUsdLocalBeneficiaryBankAccountDetails | null;
  ibanPayment: IIbanBeneficiaryBankAccountDetails | null;
  swiftPayment: ISwiftBeneficiaryBankAccountDetails | null;
  swiftUnknown: ISwiftUnknownBeneficiaryBankAccountDetails | null;
  paymentType: number;
  beneficiaryAddress: IBeneficiaryAddress;
}
